import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import TableFilter from "./TableFilter";
import Pagination from "../pagination/Pagination";
import { capitalize } from "../../../helpers/Utils";
import useTranslator from "../../../hooks/useTranslator";

const Datatable = ({
  tableData,
  columns,
  title,
  buttons,
  onPageChange,
  page,
  pageLimit = 10,
  showCount = true,
  showPegination = true,
  tab = false,
  activeTab,
  onTabChange,
  showFilter = {},
  showFilterButton = false,
  filterModule = null,
  date,
  filters = {},
  filterProps = {},
  isLoading = false,
  totalRecordsTitle=""
}) => {
  const [itemsPerPage, setItemsPerPage] = useState(pageLimit);
  const [totalItems, setTotalItems] = useState(0);
  const { _t } = useTranslator();

  useEffect(() => {
    if (tableData && tableData.data && Array.isArray(tableData.data)) {
        setTotalItems(tableData?.pagination?.total);
    } else {
      setTotalItems(0);
    }
  }, [tableData]);

  if (!columns || !Array.isArray(columns)) {
    console.warn("columns is undefined or not an array:", columns);
    columns = [];
  }

  const getNestedValue = (obj, accessor, capi, translate) => {
    let value = accessor
      ?.split(".")
      .reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : ""),
        obj
      );

    if (value && capi) {
      value = capitalize(value);
    }

    if (translate) {
      return _t(value);
    }
    return value;
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  return (
    <div
      className={
        totalPages > 1
          ? "table_wrapper d-flex flex-column"
          : "table_wrapper d-flex flex-column singlePage"
      }
    >
      <TableFilter
        title={title}
        totalRecordsTitle={totalRecordsTitle}
        buttons={buttons}
        count={tableData?.pagination?.total}
        showCount={showCount}
        showFilter={showFilter}
        tab={tab}
        activeTab={activeTab}
        onTabChange={onTabChange}
        showFilterButton={showFilterButton}
        date={date}
        filterModule={filterModule}
        filters={filters}
        filterProps={filterProps}
      />
      <div className={"flex-grow-1"}>
        <Table responsive="sm" className="mb-0">
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th key={index}>{column.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData?.data?.length > 0 ? (
              tableData?.data?.map((row, rowIndex) => (
                <tr key={rowIndex} className={row.status === "moved" ? "rework-moved-row" : ""}>
                  {columns.map((column, colIndex) => {
                    let cellContent;

                    if (column.cell) {
                      cellContent = column.cell({
                        row,
                        value: getNestedValue(
                          row,
                          column.accessor,
                          column.captialize || false,
                          column.translate || false
                        ),
                        index: rowIndex,
                      });
                    } else {
                      cellContent = getNestedValue(
                        row,
                        column.accessor,
                        column.captialize || false,
                        column.translate || false
                      );
                    }

                    return <td key={colIndex}>{cellContent}</td>;
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} className="text-center">
                  {isLoading
                    ? _t("loading", "Loading...")
                    : _t("no_data", "No data available")}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <br />
      {showPegination && totalPages > 1 && (
        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default Datatable;
